import { AppState } from 'types';
import { DocumentTypes } from 'types/inspection';

const initialAppState: AppState = {
  loginAttempts: [],
  snackMessage: { open: false, message: '' },
  snackMessageQueue: [],
  fetchingDifferences: false,
  autosaving: false,
  updatingInspection: false,
  startingInspection: false,
  resetIdleTimer: false,
  popUpNotifications: [],
  userPreferences: {},
  savedDisplaySettings: {},
  toastStatuses: {
    hasPanToolToastShown: false,
  },
  integrations: [],
  displayName: '',
  showLiveText: false,
  focusedMatchIndex: -1,
  showDifferenceBoxes: true,
  hideOtherDifferences: true,
  showOverlay: true,
  showTextHighlights: true,
  grayscaleMode: false,
  singlePageView: false,
  showRepeats: true,
  graphicMode: 'flashing',
  lastGraphicMode: 'flashing',
  transparencyOpacity: 0.5,
  cloningOperations: [],
  isCloningModalOpen: false,
  closeConfirm: false,
  isReopenedSession: false,
  unavailableFiles: [],
  selectedModule: 'All',
  hideDisplayPanels: { [DocumentTypes.source]: false, [DocumentTypes.target]: false },
  showMarkupTab: false,
};

export default initialAppState;
